<template>
  <transition
    appear
    name="slither"
  >
    <div
      class="ModalBox ModalBox--r"
      :class="modalClass"
    >
      <div class="ModalBox-header d-flex position-absolute p-3">
        <button
          class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--close"
          @click="handleClose"
        >
          <img
            class="Fuell-IconButton--close-img"
            :src="require('@/assets/img/icons/close.svg')"
            alt="Close"
          />
        </button>
        <div class="Tit Tit--modal">
          {{ title }}
        </div>
        <slot name="extraAction"></slot>
      </div>
      <div
        class="ModalBox-container position-relative pl-3 pr-3 pt-3 pb-3 mt-5"
        :class="containerClass"
      >
        <slot name="content"></slot>
      </div>
      <div
        v-if="!!$slots.footer"
        :class="footerClass"
      >
        <slot name="footer"></slot>
      </div>
      <slot name="modals"></slot>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'LateralModal',
  props: {
    title: {
      type: String,
      default: ''
    },
    modalClass: {
      type: String,
      default: ''
    },
    containerClass: {
      type: String,
      default: ''
    },
    footerClass: {
      type: String,
      default: 'ModalBox--footer w-100 p-3 d-flex flex-column'
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.Tit--modal {
  flex: 1;
}
</style>
